(function () {

var cfg = window.googlePayConfig || {};
cfg.totalExpressPrice     = Number(cfg.totalExpressPrice);
cfg.defaultTransportPrice = Number(cfg.defaultTransportPrice);

var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};

var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        'gateway': 'checkoutltd',
        'gatewayMerchantId': cfg.checkoutPublicKey
    }
};

var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        allowedCardNetworks: ["MASTERCARD", "VISA"]
    }
};

var cardPaymentMethod = Object.assign(
    {},
    baseCardPaymentMethod,
    {
        tokenizationSpecification: tokenizationSpecification
    }
);

var paymentsClient = null;
var shippingPrices = {};

function getGoogleIsReadyToPayRequest() {
    return Object.assign(
        {},
        baseRequest,
        {
            allowedPaymentMethods: [baseCardPaymentMethod]
        }
    );
}

function getGooglePaymentDataRequest() {
    var paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.merchantInfo = {
        merchantId: 'BCR2DN4T2P4NR7IH',
        merchantName: cfg.shopName
    };
    return paymentDataRequest;
}

function getGooglePaymentsClient() {
    if (paymentsClient === null) {
        paymentsClient = new google.payments.api.PaymentsClient({
            environment: cfg.googleEnvironment,
            paymentDataCallbacks: {
                onPaymentDataChanged: onPaymentDataChanged,
            }
        });
    }
    return paymentsClient;
}

function onPaymentDataChanged(intermediatePaymentData) {
    return new Promise(function (resolve) {
        var paymentDataRequestUpdate = {};

        switch (intermediatePaymentData.callbackTrigger) {
            case "INITIALIZE":
                // Handle initialize
                break;
            case "SHIPPING_ADDRESS":
                // Read intermediatePaymentData.transactionInfo
                // Read intermediatePaymentData.shippingAddress
                // Update paymentDataRequestUpdate.newTransactionInfo
                break;
            case "SHIPPING_OPTION":
                var newTransportPriceId = intermediatePaymentData.shippingOptionData.id;
                var newTransportPrice = shippingPrices[newTransportPriceId];
                paymentDataRequestUpdate.newTransactionInfo = getGoogleTransactionInfo(cfg.totalExpressPrice, newTransportPrice);
                break;
            case "OFFER":
                // Read intermediatePaymentData.offerData
                // Read intermediatePaymentData.transactionInfo
                // Update paymentDataRequestUpdate.newTransactionInfo
                // Update paymentDataRequestUpdate.newOfferInfo
                break;
            default:
                // Update paymentDataRequestUpdate.error
        }

        resolve(paymentDataRequestUpdate);
    });
}

// init and rebuild logic
function onGooglePayLoaded() {
    var client = getGooglePaymentsClient();
    client.isReadyToPay(getGoogleIsReadyToPayRequest())
        .then(function (response) {
            if (response.result) {
                var freshClient = getGooglePaymentsClient();
                var button = freshClient.createButton({
                    onClick: onGooglePaymentButtonClicked,
                    buttonSizeMode: 'fill',
                    buttonLocale: cfg.shopLang,
                    buttonType: 'plain',
                });

				// GTM
                var container = document.getElementById('gPayButton');
                container.appendChild(button);
            }
        })
        .catch(function (err) {
            console.error(err);
        });
}

function onGooglePaymentButtonClicked() {

    if ($('#gPayButton').hasClass('disabled')) {
        rebuildGPayButton();
        return;
    }
    initializeWidget();
}

// rebuilding button after unsuccessful external window operation (mainly for non-chrome/google browsers)
function rebuildGPayButton() {
    var container = document.getElementById('gPayButton');
    container.innerHTML = '';
    paymentsClient = null;
    var freshClient = getGooglePaymentsClient();
    var button = freshClient.createButton({
        onClick: onGooglePaymentButtonClicked,
        buttonSizeMode: 'fill',
        buttonLocale: cfg.shopLang,
    });
    container.appendChild(button);
}
// \\ -- init and rebuild logic

function getGoogleTransactionInfo(productPrice, transportPrice) {
    var totalPrice = Number(productPrice) + Number(transportPrice);

    return {
        countryCode: cfg.expressCountryCode,
        currencyCode: cfg.currencyCode,
        totalPriceStatus: 'FINAL',
        totalPrice: totalPrice.toFixed(2).toString(),
        totalPriceLabel: cfg.totalPriceLabel,
    };
}

function getSelectedOption() {
    var form = document.getElementById('addToBasket');
    var data = $(form).serializeArray();
    var size = '';
    data.forEach(function (dataObject) {
        if (dataObject.name === 'detail_size') {
            size = dataObject.value;
        }
    });
    return size;
}

function initializeWidget() {
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo(cfg.totalExpressPrice, cfg.defaultTransportPrice);
    var size = getSelectedOption();
    if (!size) {
        return;
    }

    shippingPrices = cfg.transportPrices;

    var sizeInMs = cfg.msSizeIds && cfg.msSizeIds.includes(parseInt(size));
    var transportsData = {
        shippingOptions: cfg.transportsData.shippingOptions.filter(function (t) {
            if (cfg.msOnlyTransportIds && cfg.msOnlyTransportIds.includes(parseInt(t.id))) {
                return sizeInMs;
            }
            return true;
        })
    };

    paymentDataRequest.shippingOptionParameters = transportsData;
    paymentDataRequest.shippingAddressParameters = {
        "allowedCountryCodes": cfg.allowedCountryCodes,
        "phoneNumberRequired": true,
        "format": "FULL-ISO3166"
    };
    paymentDataRequest.callbackIntents = [
        'SHIPPING_ADDRESS',
        'SHIPPING_OPTION',
    ];
    paymentDataRequest.shippingAddressRequired = true;
    paymentDataRequest.shippingOptionRequired = true;
    paymentDataRequest.emailRequired = true;

    var client = getGooglePaymentsClient();

    client.loadPaymentData(paymentDataRequest)
        .then(function (paymentData) {
            var paymentToken = paymentData.paymentMethodData.tokenizationData.token;
            paymentData.shippingPrice = shippingPrices[paymentData.shippingOptionData.id];
            paymentData.transportId = paymentData.shippingOptionData.id;
            paymentData.option = size;
            paymentData.productId = cfg.productId;
            paymentData.paymentId = cfg.paymentId;
            paymentData.paymentToken = paymentToken;

            $.ajax({
                url: cfg.createExpressOrderUrl,
                type: 'POST',
                data: paymentData
            }).done(function (payload) {
                if (payload.status === 200) {
                    window.location.href = payload.redirectUrl;
                }
                if (parseInt(payload.status) >= 400) {
                    showToast(cfg.paymentFailedText, {
						type: 'toast',
                        svg: 'danger',
                        delay: 20000,
                        innerClass: 'global-toast--danger',
                    });
                }
            });
        })
        .catch(function (err) {
            console.log('error', err);
        });
}

window.onGooglePayLoaded = onGooglePayLoaded;

}());
